import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';

import './styles.scss';

import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import FormContent from 'components/organisms/formContent';
import FormActions from 'components/molecules/formActions';
import FormCol from 'components/molecules/formCol';
import TabNav from 'components/organisms/tabNav';
import TabNavItem from 'components/atoms/tabNavItem';
import FormFieldset from 'components/molecules/formFieldset/index.jsx';
import FormTextField from 'components/molecules/formTextField/index.jsx';
import FormTextFieldLegend from 'components/atoms/formFieldsetLegend/index.jsx';
import WizardProgress from 'components/organisms/wizard/progress';

import validate from '../validate';

class PersonalInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      company: false,
    };
  }

  canContinue() {
    const { personalInformation } = this.props;

    return (
      personalInformation &&
      personalInformation.dni &&
      personalInformation.cellphone &&
      personalInformation.email
    );
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="personalInfo">
        <Header inFlow />
        <WizardProgress step="6" />
        <section className="stepContent">
          <div className="container">
            <div className="col">
              <h2>Ingresa tus datos</h2>
              <p className="m">
                Ya casi terminamos, te pedimos tus datos para poder contactarte.
              </p>
              <form onSubmit={handleSubmit}>
                <FormContent nomargins>
                  <TabNav justified>
                    <TabNavItem
                      justified
                      active={this.state.company === false}
                      style="blue"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ company: false });
                      }}
                    >
                      Persona
                    </TabNavItem>
                    <TabNavItem
                      justified
                      active={this.state.company === true}
                      style="blue"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ company: true });
                      }}
                    >
                      Empresa
                    </TabNavItem>
                  </TabNav>
                  <FormFieldset divider>
                    <FormCol single>
                      <FormTextFieldLegend>Datos personales</FormTextFieldLegend>
                      {!this.state.company && (
                        <div className="fieldGroup">
                          <Field
                            component={FormTextField}
                            name="personal_information.name"
                            label="Nombre"
                            type="text"
                            inline
                            size="m"
                          />
                          <Field
                            component={FormTextField}
                            name="personal_information.lastname"
                            label="Apellido"
                            type="text"
                            inline
                            size="m"
                          />
                        </div>
                      )}
                      {this.state.company && (
                        <Field
                          component={FormTextField}
                          name="personal_information.company"
                          label="Empresa"
                          type="text"
                          inline
                          size="b"
                        />
                      )}
                      <Field
                        component={FormTextField}
                        name="personal_information.dni"
                        label={this.state.company ? 'CUIT' : 'DNI'}
                        type="text"
                      />
                    </FormCol>
                  </FormFieldset>
                  <FormFieldset divider>
                    <FormCol single>
                      <FormTextFieldLegend>Datos de contacto</FormTextFieldLegend>
                      <Field
                        component={FormTextField}
                        name="personal_information.telephone"
                        label="Telefono"
                        type="text"
                        inline
                        size="m"
                      />
                      <Field
                        component={FormTextField}
                        name="personal_information.cellphone"
                        label="Celular"
                        type="text"
                        inline
                        size="m"
                      />

                      <Field
                        component={FormTextField}
                        name="personal_information.address"
                        label="Domicilio"
                        type="text"
                        size="b"
                      />

                      <Field
                        component={FormTextField}
                        name="personal_information.email"
                        label="Email"
                        type="text"
                        size="b"
                        helpText="Te enviaremos a este email la confirmación y recordatorios del turno."
                      />
                    </FormCol>
                  </FormFieldset>
                  <FormActions back={this.props.previousPage}>
                    <Button type="submit" buttonText="Continuar" disabled={!this.canContinue()} />
                  </FormActions>
                </FormContent>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

PersonalInfo = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PersonalInfo);

const selector = formValueSelector('shiftRequest');

PersonalInfo = connect(state => {
  return {
    personalInformation: selector(state, 'personal_information'),
  };
})(PersonalInfo);

export default PersonalInfo;
